export default "__VITE_ASSET__SjnaQw1b__";